import React, { Component } from 'react';
import { getFileName } from 'helpers/FileCaching';
import classes from './Hero.module.scss';
import GoldSocialIcon from '../GoldSocialIcon/GoldSocialIcon'
import renderHTML from 'react-render-html';
import globalJSON from 'data/global.json';

const heroImages = require.context('images/components/Articles/Article/Hero', true, /.*\.(gif|png|jpe?g|svg)$/i);

class Hero extends Component {

    render(){
        return (
            <div className={classes.hero}>
                <div className={classes.hero__image_wrapper}>   
                    <div
                        title={this.props.content.alt} 
                        className={classes.hero__image}
                        style={

                            {
                                backgroundImage: 'url(' + getFileName(heroImages, this.props.content.image[this.props.windowSize]) + ')'
                            }
                            
                        }
                    >
                        <div className={classes.hero__image_overlay}></div>
                        <h1 className={classes.hero__title}>{renderHTML(this.props.content.caption)}</h1>
                    </div>
                </div>
                <div className={classes.hero__SocialContainer}>
                    <GoldSocialIcon content={this.props.socialContent} url={`${globalJSON.live_url}${process.env.PUBLIC_URL}/${this.props.url}`} />
                    
                </div>
            </div>
        );
    }
}

export default Hero;